import { useEffect, useState } from "react";
import CommonService from "../services/common/commonService";

export const useNotificationCount = (
  userProfileOrgId: string,
  isNotificationsEnabled: boolean
) => {
  const [notificationCount, setNotificationCount] = useState<number>(0);

  // Only one stable query key, no JSON.stringify
  const {
    isSuccess,
    isError,
    error,
    data,
    refetch: getNotificationCountRefetch,
  } = CommonService.useGetNotificationCount({
      userProfileOrgId,
  },
    !!userProfileOrgId && isNotificationsEnabled
  );

  useEffect(() => {
    if (isSuccess) {
      const count = data?.data?.count || "0";
      setNotificationCount(count);
    } else if (isError) {
      console.error("Notification count error:", error?.message);
    }
  }, [isSuccess, isError, data, error]);
  const decrementNotificationCount = (amount: number = 1) => {
    setNotificationCount((prev) => Math.max(prev - amount, 0));
  };

  return {notificationCount, getNotificationCountRefetch, decrementNotificationCount};
};
